/**
 * @license
 * Copyright Tyler Technologies, Inc. 
 * License: Apache-2.0
 */
const observedAttributes = {
    MIN: 'min',
    MAX: 'max',
    OPEN: 'open',
    DISABLED: 'disabled',
    POPUP_CLASSES: 'popup-classes',
    MASKED: 'masked',
    MASK_FORMAT: 'mask-format',
    SHOW_MASK_FORMAT: 'show-mask-format',
    VALUE_MODE: 'value-mode',
    ALLOW_INVALID_DATE: 'allow-invalid-date',
    SHOW_TODAY: 'show-today',
    SHOW_CLEAR: 'show-clear',
    DISABLED_DAYS_OF_WEEK: 'disabled-days-of-week',
    YEAR_RANGE: 'year-range',
    LOCALE: 'locale',
    CALENDAR_TEXT: 'calendar-text'
};
const attributes = {
    TOGGLE: 'forge-date-picker-toggle'
};
const selectors = {
    INPUT: 'input',
    TOGGLE: '[forge-date-picker-toggle],[data-forge-date-picker-toggle]'
};
export const BASE_DATE_PICKER_CONSTANTS = {
    observedAttributes,
    attributes,
    selectors
};
